import { Family, FamilyMembers } from './Family';

export function create(name: string, members: FamilyMembers): Family {
  const family: Family = {
    name,
    members,
    syncState: {
      asOf: new Date(),
      description: 'Ready for Sync',
    },
  };
  return family;
}
